module.exports = __webpack_public_path__ + "static/media/S1N9-6.3c7474a1.svg";